
import { Vue } from "vue-class-component";

export default class MapsV2 extends Vue {}
